<div class="w-12"
     [ngStyle]="{'minHeight': client.isCms ? '10px' : undefined}">
    @if(canShow) {
    <div class="wrap p-r-6-l p-r-7-s"
         [ngClass]="component?.background_color || 'bg-col-51'">

        <div class="c-5 c-12-s p-t-13 p-t-9-s m-b-0 center left-s">
            <h2 class="w-12 h2 left inline-block"
                [htmlBinding]="header"></h2>
            <ng-container *ifSize="'XL'">
                <ng-container *ngTemplateOutlet="extraCopy"></ng-container>
            </ng-container>
        </div>

        <div class="c-6 c-7-m c-12-s p-l-5 p-b-8-x p-b-8-l p-l-0-m p-t-3 p-t-1-s p-l-0-s m-b-0 m-r-0">
            @for (item of faqs; track item; let i = $index) {
            <div class="p-t-9 p-t-6-s p-b-6 p-b-5-s b-b b-col-11">
                <h3 class="cursor-pointer flex flex-middle flex-justify-between"
                    [zippyToggle]="[uid, i]"
                    zippyClass="is-open">
                    <span class="h3 p-r-5-s"
                          [ngClass]="item.question_size || ''"
                          *iCms="'question' of item; content: 'html'"></span>
                    <i class="p-r-3-s col-11"
                       zippyClass="icon-minus !icon-plus"
                       [zippyName]="[uid, i]"
                       [style.font-size.rem]="client.isS ? 0.8 : 1">
                    </i>
                </h3>
                <div class="hide-up-container">
                    <div class="ng-hide-animate hide-up hide-up-100 p1 p-t p-r-5-s"
                         [ngClass]="item.answer_size || ''"
                         [zippy]="[uid, i]"
                         *iCms="'answer' of item; content: 'html'">
                    </div>
                </div>
            </div>
            }
            <ng-container *ifSize="'MS'">
                <ng-container *ngTemplateOutlet="extraCopy"></ng-container>
            </ng-container>
        </div>
    </div>

    <ng-template #extraCopy>
        @if (component?.extra_copy || component?.cta_copy) {
        <div class="left-x left-l p-t-16 p-b-16 p-t-8-s p-b-8-s">
            <span class="p1 p-r-1"
                  *iCms="'extra_copy' of component; content: 'html'; skipEmpty: true"></span>
            <href [link]="component?.cta_link">
                <span class="button-inline p1"
                      *iCms="'cta_copy' of component; skipEmpty: true"></span>
            </href>
        </div>
        }
    </ng-template>
    }
</div>
